import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLBoolean,
  GraphQLInt,
  GraphQLNonNull,
  GraphQLID,
  GraphQLFloat,
  GraphQLList
} from 'graphql';
import { toGlobalId } from 'graphql-relay';
import GraphQLJSON from 'graphql-type-json';

import Node from './node.gql';
import CardType from './card.gql';
import CompletionStatusEnumType from './enums/completionStatus.gql';
import SuccessStatusEnumType from './enums/successStatus.gql';

const CompletionStatusEnum = {
  complete: 'COMPLETE',
  inComplete: 'IN_COMPLETE',
  notAttempted: 'NOT_ATTEMPTED'
};

const SuccessStatusEnum = {
  pass: 'PASS',
  fail: 'FAIL',
  na: 'NA'
};

const coursePerformance = new GraphQLObjectType({
  name: 'CoursePerformance',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: root => toGlobalId('CoursePerformance', `${root.contentId}-${root.userId}`)
    },
    pid: {
      type: GraphQLString,
      resolve: root => root.contentId
    },
    state: {
      type: GraphQLJSON,
      resolve: root => root
    },
    complete: {
      type: GraphQLBoolean,
      resolve: item => item.completionStatus === CompletionStatusEnum.COMPLETE
    },
    timeSpent: {
      type: GraphQLInt,
      resolve: root => Math.ceil(root.timeSpent)
    },
    visibleCompleted: {
      type: GraphQLInt,
      resolve: () => 0
    },
    lastUpdatedTimeSpent: {
      type: GraphQLString,
      resolve: root => (root.lastUpdatedTimeSpent ? root.lastUpdatedTimeSpent : new Date().toISOString())
    },
    lastUpdatedComplete: {
      type: GraphQLString,
      resolve: root => (root.lastUpdatedComplete ? root.lastUpdatedComplete : new Date().toISOString())
    },
    lastUpdated: {
      type: GraphQLString
    },
    completionDate: {
      type: GraphQLString,
      resolve: root => root.completedOn
    },
    progressMeasure: {
      type: GraphQLFloat
    },
    scaledProgressMeasure: {
      type: GraphQLFloat
    },
    totalCards: {
      type: GraphQLInt
    },
    lastVisitedCard: {
      type: new GraphQLList(CardType),
      resolve: item => item.lastVisitedCard.slice() // TODO
    },
    completionStatus: {
      type: CompletionStatusEnumType,
      resolve: item => CompletionStatusEnum[item.completionStatus]
    },
    successStatus: {
      type: SuccessStatusEnumType,
      resolve: item => SuccessStatusEnum[item.successStatus]
    },
    startDate: {
      type: GraphQLString,
      resolve: item => item.startedOn
    },
    isRequired: {
      type: GraphQLBoolean,
      resolve: item => (item.isRequired ? item.isRequired : false)
    }
  }),
  interfaces: [Node.nodeInterface]
});

export default coursePerformance;
